var g = (w, _, u) => new Promise((c, d) => {
  var t = (r) => {
    try {
      a(u.next(r));
    } catch (m) {
      d(m);
    }
  }, f = (r) => {
    try {
      a(u.throw(r));
    } catch (m) {
      d(m);
    }
  }, a = (r) => r.done ? c(r.value) : Promise.resolve(r.value).then(t, f);
  a((u = u.apply(w, _)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { postSpecialApplyCreate as F } from "../../request/designordercenter/productionOrder/specialApply/create/post.js";
import { getDict as N } from "@oppein/op-utils";
import { defineComponent as S, useTemplateRef as h, onMounted as M, openBlock as E, createElementBlock as U, createElementVNode as C, createVNode as l, withCtx as i, createTextVNode as D, Fragment as Y } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as j } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as s, unref as n } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import q from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import z from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import L from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import k from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import { toDisplayString as G } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import H from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import I from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import J from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const K = { style: { width: "100%", display: "flex", "justify-content": "center" } }, de = /* @__PURE__ */ S({
  __name: "aiPutCaseDialog.ce",
  emits: ["submit"],
  setup(w, { expose: _, emit: u }) {
    const c = h("aiPutCaseDialogContainer"), d = j(), t = s(!1), f = h("formRef");
    s(""), s([]);
    const a = s(!1), r = s([]), m = s([]), p = s({
      modifyReason: ""
    }), R = s(""), P = {
      modifyReason: {
        required: !0,
        message: "请输入例放内容",
        trigger: ["blur", "input"]
      }
    }, O = () => g(this, null, function* () {
      const [o, e] = yield Promise.all([N("ROOT_brand"), N("ROOT_category")]);
      r.value = o, m.value = e;
    }), v = () => {
      var o;
      p.value = {
        modifyReason: ""
      }, (o = f.value) == null || o.restoreValidation();
    }, T = () => g(this, null, function* () {
      var o;
      try {
        yield (o = f.value) == null ? void 0 : o.validate(), a.value = !0;
        const e = yield F({
          orderId: b.value.orderId,
          specialApplyType: "put_case_bpm_process",
          content: p.value.modifyReason,
          isAutomatic: 1
        });
        e && e.status ? (d.success("订单例放申请已提交，请等待审批"), t.value = !1, v(), a.value = !1) : (a.value = !1, t.value = !1), v();
      } catch (e) {
        a.value = !1, e != null && e.errors || (console.error("请求失败:", e), d.error("请完善必填信息"));
      }
    }), b = s({
      orderId: ""
    });
    M(() => g(this, null, function* () {
      yield O();
    }));
    let y = null;
    function V(o) {
      b.value.orderId = o.orderId || "", R.value = o.productionOrderContractNo || "", t.value = !0;
    }
    const A = () => {
      t.value = !1, v(), y = null, b.value = {
        orderId: ""
      };
    }, B = () => {
      t.value = !1, v(), y && (y([]), y = null);
    };
    return _({ open: V }), (o, e) => (E(), U(Y, null, [
      C("div", {
        ref_key: "aiPutCaseDialogContainer",
        ref: c
      }, null, 512),
      l(n(J), {
        bordered: "",
        show: t.value,
        "onUpdate:show": e[1] || (e[1] = (x) => t.value = x),
        "mask-closable": !1,
        "z-index": 9999,
        to: c.value || "body"
      }, {
        default: i(() => [
          l(n(q), { show: a.value }, {
            default: i(() => [
              l(n(z), {
                style: { width: "800px" },
                title: "例放申请",
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: A
              }, {
                default: i(() => [
                  l(n(L), {
                    ref_key: "formRef",
                    ref: f,
                    model: p.value,
                    rules: P,
                    "label-placement": "left",
                    "label-width": "130px"
                  }, {
                    default: i(() => [
                      l(n(k), { label: "订单编号：" }, {
                        default: i(() => [
                          C("span", null, G(R.value || "OPLYC深圳市26010200001YA1-1"), 1)
                        ]),
                        _: 1
                      }),
                      l(n(k), {
                        label: "例放内容：",
                        path: "modifyReason"
                      }, {
                        default: i(() => [
                          l(n(H), {
                            type: "textarea",
                            value: p.value.modifyReason,
                            "onUpdate:value": e[0] || (e[0] = (x) => p.value.modifyReason = x),
                            placeholder: "请输入例放内容，最多500字",
                            maxlength: 500,
                            "show-count": "",
                            style: { width: "600px", "min-height": "100px" }
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  C("div", K, [
                    l(n(I), {
                      onClick: B,
                      style: { "margin-top": "22px", "border-radius": "5px" }
                    }, {
                      default: i(() => e[2] || (e[2] = [
                        D("取消", -1)
                      ])),
                      _: 1,
                      __: [2]
                    }),
                    l(n(I), {
                      onClick: T,
                      style: { "margin-left": "30px", "margin-top": "22px", "background-color": "#3370ff !important", "border-color": "#3370ff !important", "--n-border": "1px solid #3370ff", "--n-button-color": "#fff !important", "border-radius": "5px" },
                      type: "primary"
                    }, {
                      default: i(() => e[3] || (e[3] = [
                        D("确认", -1)
                      ])),
                      _: 1,
                      __: [3]
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  de as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-put_case-dialog/aiPutCaseDialog.ce.vue.js
// module id = 1204
// module chunks = 67